import React from "react";

export default class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI hatası:", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3 p-6 text-center bg-background text-foreground" data-testid="ui-error">
        <div className="font-heading text-xl font-bold">Bir şeyler ters gitti</div>
        <p className="text-sm text-muted-foreground max-w-md break-words">{String(this.state.error?.message || this.state.error)}</p>
        <div className="flex gap-2">
          <button onClick={() => this.setState({ error: null })} className="h-10 px-4 rounded-lg border border-border text-sm" data-testid="ui-error-back">Geri dön</button>
          <button onClick={() => window.location.reload()} className="h-10 px-4 rounded-lg bg-primary text-primary-foreground text-sm font-semibold" data-testid="ui-error-reload">Sayfayı yenile</button>
        </div>
      </div>
    );
  }
}
